module.exports = __webpack_public_path__ + "static/media/icon-dashboard-projected-commission.fad3caee.svg";